const countFormatter = new Intl.NumberFormat('fr-FR');

/** e.g. 10000 → "10 000" */
export function formatCount(count) {
  const n = Number(count);
  if (!Number.isFinite(n)) {
    return '';
  }
  return countFormatter.format(n).replace(/\u202f/g, ' ');
}

export function formatNameWithCount(name, count) {
  const formatted = formatCount(count);
  if (formatted === '') {
    return name;
  }
  return `${name} (${formatted})`;
}

/** First word of a category label, e.g. "Fashion, apparel & footwear" → "Fashion". */
export function shortCategoryName(name) {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  if (trimmed === '') {
    return '';
  }
  const firstSegment = trimmed.split(',')[0]?.trim() ?? trimmed;
  const firstWord = firstSegment.split(/\s+/)[0]?.replace(/[,;:]+$/u, '') ?? '';
  return firstWord !== '' ? firstWord : firstSegment;
}

export function formatShortNameWithCount(name, count) {
  const shortName = shortCategoryName(name);
  const formatted = formatCount(count);
  if (formatted === '') {
    return shortName;
  }
  return `${shortName} (${formatted})`;
}

/** Remainder of category label after the short name, e.g. "apparel & footwear". */
export function categoryNameSubtitle(name) {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  if (trimmed === '') {
    return '';
  }
  const commaIndex = trimmed.indexOf(',');
  if (commaIndex >= 0) {
    return trimmed.slice(commaIndex + 1).trim();
  }
  const firstSegment = trimmed.split(',')[0]?.trim() ?? trimmed;
  const words = firstSegment.split(/\s+/);
  if (words.length <= 1) {
    return '';
  }
  return words.slice(1).join(' ');
}

const priceRangeFormatter = new Intl.NumberFormat('mt-MT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** e.g. 0.5, 5 → "€0.50 – €5.00" */
export function formatPriceCollectionRange(priceMin, priceMax) {
  const min = Number(priceMin);
  const max = Number(priceMax);
  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    return '';
  }
  return `${priceRangeFormatter.format(min)} – ${priceRangeFormatter.format(max)}`;
}

/** Active browse categories only — excludes inactive "coming soon" entries. */
export function browseCategoriesForDropdown(
  categories,
  activeShopCategorySlug = '',
) {
  return browseCategoriesForNav(categories, activeShopCategorySlug).filter(
    (c) => !c.comingSoon,
  );
}

/**
 * Footer and category menu: hide price-collection bands unless the user is
 * currently browsing that collection.
 */
export function browseCategoriesForNav(
  categories,
  activeShopCategorySlug = '',
) {
  const active = (activeShopCategorySlug ?? '').toLowerCase();
  return (Array.isArray(categories) ? categories : []).filter((c) => {
    if (c.priceCollection === true) {
      return active !== '' && (c.slug ?? '').toLowerCase() === active;
    }
    return true;
  });
}
